import { LitElement, html } from "lit";
import { unsafeHTML } from "lit/directives/unsafe-html.js";
import { tabStyles } from "js/sharedStyles/tab.js";
import { tabsStyles } from "js/sharedStyles/tabs.js";

import { AsyncHelper } from "/js/tools/async.helper.js";
function partMap(parts) {
  return Object.entries(parts)
    .filter(([key, value]) => value)
    .map(([key, value]) => key)
    .join(" ");
}

class Tabs extends LitElement {
  static get properties() {
    return {
      defaultTab: {
        type: Number,
        attribute: "data-default-tab",
      },
      isClosable: {
        type: Boolean,
        attribute: "data-is-closable",
        reflect: true,
      },
      tooltip: { type: String, reflect: true, state: true },
    };
  }
  static styles = [
    tabsStyles,
  ];

  constructor() {
    super();
  }
  get tabs() {
    const slot = this.shadowRoot.querySelector("slot");
    return slot ? slot.assignedElements() : [];
  }

  selectTab(clickedTab) {
    let usageWidget;

    if ((usageWidget = document.querySelector(".js-usage-widget")) && clickedTab.switchInput) {
      var isGas = clickedTab.switchInput == "gas";
      usageWidget.toggleAttribute("data-show-gas", isGas);
      document.getElementById("hiddenType").value = isGas ? "gas" : "strom";
      document.getElementById("hiddenProductType").value = isGas ? "gas" : "electricity";
      document.getElementById("hiddenEnergyArea").value = isGas ? "gas" : "Electricity";

      var currentAction = document.querySelector(".js-input-widget").getAttribute("action");
      var newAction = isGas ? currentAction.replace("strom", "gas") : currentAction.replace("gas", "strom");
      document.querySelector(".js-input-widget").setAttribute("action", newAction);
    }

    if (clickedTab && clickedTab.selected == true && this.isClosable) {
      clickedTab.selected = false;
    } else {
      for (let tab of this.tabs) tab.selected = tab == clickedTab;
    }

    this.requestUpdate();
  }

  firstUpdated() {
    super.firstUpdated();
    if (this.tabs.find((tab) => tab.selected)) return;

    const hash = window.location.hash.replace(/^#/, "");
    const tabFromHash = hash ? this.tabs.find((tab) => tab.tabId === hash) : null;
    this.selectTab(tabFromHash || this.tabs[this.defaultTab]);
  }

  render() {
    return html`
      <nav part="tab-bar" class="c-tabbar">
        ${this.tabs.map(
          (tab, index) => html`
            <span part=${partMap({ tab: true, "tab-selected": tab.selected, [`tab-index-${index + 1}`]: true  })} data-index="${index + 1}" class="${tab.selected ? "tab-selected" : ""}" @click=${(ev) => this.selectTab(tab)}> ${unsafeHTML(tab.title)} </span>
            ${tab.tooltip ? html`<bc-tooltip data-trigger-style="none">${tab.tooltip}</bc-tooltip>` : ""}
          `
        )}
      </nav>

      <slot part="content" @slotchange=${(ev) => this.requestUpdate()}></slot>
    `;
  }
}

class Tab extends LitElement {
  static get properties() {
    return {
      title: { type: String, attribute: "data-tab-title" },
      tabId: { type: String, attribute: "data-tab-id" },
      content: { type: String, reflect: true },
      detailUrl: { type: String, reflect: true },
      detailPostUrl: { type: String, reflect: true },
      detailPostData: { type: String, reflect: true },
      waitingForData: { type: Boolean, state: true },
      isAsync: { type: Boolean, attribute: "data-is-async" },
      selected: { type: Boolean, reflect: true },
      switchInput: { type: String, attribute: "data-switch-input", reflect: true },
    };
  }

  static styles = [tabStyles];

  constructor() {
    super();
    this.waitingForData = this.detailUrl || this.detailPostUrl == undefined ? true : false;
  }

  async updated(changedProperties) {
    if (changedProperties.has("selected") && this.selected && this.isAsync) {
      const asyncHelper = AsyncHelper();
      let { data, status } = {};
      if (this.detailUrl) {
        ({ data, status } = await asyncHelper.getUrl(this.detailUrl));
      } else {
        let postData = JSON.parse(this.detailPostData);
        ({ data, status } = await asyncHelper.postUrl(this.detailPostUrl, postData));
      }
      this.waitingForData = false;
      if (status == 200) {
        const options = {
          detail: { data },
          bubbles: true,
          composed: true,
        };
        this.dispatchEvent(new CustomEvent("data-fetched", options));
      } else {
        throw new Error(`Failed to fetch data from ${this.detailUrl || this.detailPostUrl}`);
      }
    }
  }

  render() {
    if (!this.isAsync) {
      this.waitingForData = false;
    }
    return html` ${this.waitingForData ? html`<bc-loading-icon data-inline="true"></bc-loading-icon>` : html`<slot>${this.content}</slot>`} `;
  }
}
const initBCTabs = () => {
  if (!window.customElements.get("bc-tab")) {
    customElements.define("bc-tab", Tab);
  }

  if (!window.customElements.get("bc-tabs")) {
    customElements.define("bc-tabs", Tabs);
  }
};
export { initBCTabs };
